import { useTheme } from '@mui/material';

import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const faqData = {
  mainText: `FAQ`,
  description: `Blockchain development services with Rumble Fish`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'Q: What blockchain development services do we offer?',
      description: `A: At Rumble Fish, we offer a full scope of blockchain development services - from smart contract development, through custom Web3 product development, to decentralized exchange development. If you didn’t find an exact solution for you on our website, feel free to contact us with your brief directly, we’ll be happy to assist you!`,
      gradientOnFocus: theme.mixins.cyanGradient?.background as string,
    },

    {
      title: 'Q: What blockchain development tech stack do we use?',
      description: `A: For the exact list of technologies we use, please see the section “Tech Stack” above. We try to keep it up to date however at the speed our team is learning new stuff it’s not always possible. ;) So if you’re curious if we use a technology you have in mind, it’s best to <a href="mailto:hello@rumblefish.dev">contact our team</a> and find out directly.`,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: 'Q: What blockchains can we build on?',
      description: `A: As a blockchain development company, we are perfectly comfortable with working on any EVM-based blockchain.`,
      gradientOnFocus: theme.mixins.violetGradient?.background as string,
    },
    {
      title: 'Q: Do we develop our own blockchain tools?',
      description: `A: We sure do! At Rumble Fish, we designed and developed a couple of Web3-related tools and products. The first of them is Hadouken, which is a decentralized exchange platform for Nervos Network. Next, we decided to help fellow blockchain devs and design a unique tool that would help them in everyday tasks. The tool is called the EVM Debugger, it’s available to use free of charge for anyone, and we’re happy to say we’ve been getting great feedback so far! The third Web3 product in our own portfolio is the Deva Wallet, the Account Abstraction mobile wallet that brings you all the benefits of EIP-4337.`,
      gradientOnFocus: theme.mixins.grapeGradient?.background as string,
    },
    {
      title: 'Q: How do we find the best blockchain developers?',
      description: `A: To start with, at Rumble Fish, we put extra care into the recruitment process. We look for people who share our values and share our passion for technology. We also train blockchain developers in our own Blockchain Training Hub designed to turn software engineers into blockchain devs ready to work.`,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
    {
      title: 'Q: What does our development process look like?',
      description: `A: We don’t believe in “one size fits all”! As a boutique software company, we treat every customer as if they’re our only one. That’s why the development process might vary from project to project - we agree on the best development process model individually. What stays the same is our involvement in the project and the highest level of technical expertise.`,
      gradientOnFocus: theme.mixins.magentaGradient?.background as string,
    },
  ];
};
